module.exports = __webpack_public_path__ + "img/57-image-1-1@2x.f98e1a2a.png";